import { render, staticRenderFns } from "./404.vue?vue&type=template&id=7d85e7af&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=7d85e7af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85e7af",
  null
  
)

export default component.exports